import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { ReporteAgendamiento } from "../interface/reports-module.interface";

export const useTableColumnsReporteAgendamiento = () => {

    const columnsReporteAgendamiento = useMemo<MRT_ColumnDef<ReporteAgendamiento>[]>(
        () => [
            {
                accessorKey: 'api_cliente.razon_social',
                header: 'NOMBRE CLIENTE',
                size: 200,
            },
            {
                accessorKey: 'nombre_estado_activaciones',
                header: 'ESTADO ACTIVACIONES',
                size: 100,
            },
            {
                accessorKey: 'nombre_estado_informe_tecnico',
                header: 'ESTADO INFORME TÉCNICO',
                size: 100,
            },
            {
                accessorKey: 'api_cliente.api_ciudad.nombre',
                header: 'CIUDAD',
            },
            {
                accessorKey: 'api_cliente.api_zona.nombre',
                header: 'ZONA',
            },
            {
                accessorKey: 'api_canal_venta.nombre',
                header: 'CANAL DE VENTAS',
            },
            {
                accessorKey: "api_trazo_venta_1",
                header: "Primer",
                size: 50,
                Cell: ({ row }) => row.original?.api_trazo_venta?.[0]?.fecha_creacion?.split("T")[0] ?? "-",
            },
            {
                accessorKey: "api_trazo_venta_2",
                header: "Segundo",
                size: 50,
                Cell: ({ row }) => row.original?.api_trazo_venta?.[1]?.fecha_creacion?.split("T")[0] ?? "-",
            },
            {
                accessorKey: "api_trazo_venta_3",
                header: "Ultimo",
                size: 50,
                Cell: ({ row }) => row.original?.api_trazo_venta?.[row.original.api_trazo_venta.length - 1]?.fecha_creacion?.split("T")[0] ?? "-",
            },
            {
                accessorKey: "api_trazo_venta",
                header: "Cantidad",
                size: 50,
                Cell: ({ row }) => row.original?.api_trazo_venta.length || "0",
            },
        ],
        [],
    );

    return {
        columnsReporteAgendamiento,
    }
}